var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWavingHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9002 36.9726C15.8714 36.9726 15.84 36.9674 15.8086 36.9595C12.6596 35.9997 9.24908 32.5577 8.50891 29.5944C8.46706 29.427 8.56906 29.2596 8.73384 29.2178C8.90123 29.176 9.06861 29.278 9.11046 29.4427C9.79309 32.1759 13.0729 35.474 15.9891 36.3658C16.1539 36.4155 16.2454 36.5881 16.1957 36.7529C16.1565 36.8863 16.0336 36.9726 15.9002 36.9726Z",
    fill: "#975500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4016 40.8775C17.3781 40.8775 17.3545 40.8749 17.331 40.8696C14.726 40.2628 11.6973 38.317 9.02434 35.5289C6.52397 32.9239 4.90501 30.1515 4.80039 28.2946C4.78993 28.1246 4.9207 27.9755 5.09332 27.9676C5.26333 27.9572 5.41241 28.0879 5.42025 28.2606C5.51441 29.9501 7.1046 32.6336 9.47158 35.1C12.0635 37.8043 14.9797 39.6848 17.4722 40.2655C17.6396 40.3047 17.7442 40.4721 17.705 40.6395C17.671 40.7807 17.5429 40.8775 17.4016 40.8775Z",
    fill: "#975500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7534 13.7004C30.6148 13.7004 30.4893 13.6088 30.4526 13.4702C30.0159 11.812 28.0307 9.43196 26.2235 8.96641C26.0587 8.92456 25.9567 8.75456 26.0012 8.58717C26.0456 8.41978 26.213 8.32039 26.3804 8.36485C28.4152 8.89056 30.5651 11.4563 31.0542 13.3133C31.0987 13.4781 30.9993 13.6481 30.8319 13.6925C30.8057 13.6978 30.7796 13.7004 30.7534 13.7004Z",
    fill: "#975500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6689 14.2522C34.5303 14.2522 34.4047 14.1581 34.3681 14.0195C33.2043 9.43719 28.8521 5.86187 26.3675 5.41724C26.1975 5.38586 26.0876 5.22632 26.1164 5.05631C26.1478 4.88631 26.3073 4.77646 26.4773 4.80523C29.1843 5.2917 33.7247 8.97687 34.9697 13.8651C35.0115 14.0325 34.9121 14.1999 34.7448 14.2418C34.7186 14.2496 34.6951 14.2522 34.6689 14.2522Z",
    fill: "#975500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.94 22.3941C27.4396 22.946 27.8894 23.6704 27.6985 23.8614C27.5076 24.0523 26.9217 23.7071 26.4745 23.2572C26.0272 22.81 24.9575 27.5701 24.8529 27.8107C24.7744 27.9912 23.5295 29.4192 22.8782 30.7766C22.6611 31.2291 22.6925 32.5944 22.6114 32.6754C22.2845 33.0024 21.8687 32.9684 20.9716 32.1759C20.0745 31.3834 19.6089 36.1043 20.6786 36.8497C22.5068 38.126 26.1632 43.1974 30.994 43.1974C36.5832 43.1974 41.7591 37.3675 41.7591 33.0887C41.7591 28.8098 40.5037 27.1882 40.5874 23.6024C40.6554 20.5659 42.8655 19.117 42.8655 17.6C42.8655 16.3237 40.9693 16.0124 40.3468 16.0124C39.2431 16.0124 36.4132 17.4274 36.4132 21.1518C36.4132 22.6007 35.9999 23.9111 34.517 23.9111C33.034 23.9111 31.3784 21.8763 30.3767 20.2887",
    fill: "url(#paint0_linear_427_2284)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8631 17.6C42.8631 16.9069 42.3008 16.4989 41.6888 16.2687C42.4237 18.7037 38.6967 18.8083 38.6967 27.1045C38.6967 35.4007 33.866 37.8148 31.8652 38.2306C29.8643 38.6439 26.3387 38.7642 23.6553 35.4713C22.8314 34.4591 21.7146 33.3607 20.4723 32.3223C19.9466 33.1985 19.8341 36.2612 20.6789 36.8497C22.5071 38.126 26.1635 43.1974 30.9942 43.1974C36.5834 43.1974 41.7594 37.3675 41.7594 33.0886C41.7594 28.8098 40.504 27.1882 40.5877 23.6024C40.6557 20.5659 42.8631 19.1169 42.8631 17.6Z",
    fill: "url(#paint1_linear_427_2284)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9718 32.1759C20.0747 31.3834 17.9536 29.1236 16.5726 28.0173C15.1917 26.9136 13.986 26.9267 13.1569 28.1455C12.3278 29.3643 14.7444 31.5037 15.2963 32.0555C16.1411 32.9003 19.6092 36.1043 20.6789 36.8523",
    fill: "url(#paint2_linear_427_2284)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8529 27.8107C24.7483 28.0513 24.0448 28.2187 22.6455 26.6965C21.5758 25.5327 18.7119 22.1875 17.0223 20.6705C15.3327 19.1536 14.0198 18.5311 12.916 19.3262C11.8123 20.1213 12.44 21.7743 13.6745 23.1552C15.2019 24.8631 16.9595 26.605 18.6413 28.2789C19.9568 29.5866 22.9358 32.3511 22.6089 32.6781",
    fill: "url(#paint3_linear_427_2284)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6438 28.2762C19.8861 29.5107 22.6062 32.0399 22.635 32.597C23.0273 31.985 22.3106 30.1646 21.5522 29.5264C17.1687 25.836 12.9343 19.8859 12.3955 20.0637C12.1653 20.9295 12.7486 22.1169 13.6744 23.1552C15.2019 24.8605 16.9594 26.605 18.6438 28.2762Z",
    fill: "url(#paint4_linear_427_2284)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3743 20.2913C29.3726 18.7037 25.2663 13.5983 24.2672 12.1494C23.2655 10.7004 21.9212 10.7004 20.9901 11.3569C20.059 12.0134 19.7817 13.3237 21.8793 16.1092C23.2027 17.8667 24.3012 19.4831 26.9428 22.3967L30.0134 22.1822L30.3743 20.2913Z",
    fill: "url(#paint5_linear_427_2284)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4749 23.2572C26.0277 22.81 22.06 18.1074 21.1629 17.0978C19.4812 15.2095 17.3496 11.1634 14.8074 12.9654C13.4709 13.9122 14.1954 15.2853 14.5746 15.8372C14.9538 16.389 19.8866 22.0829 20.3704 22.5641C20.8543 23.048 24.9579 27.5675 24.8559 27.8081",
    fill: "url(#paint6_linear_427_2284)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9402 22.3941C27.4215 22.9251 27.853 23.6129 27.717 23.8352C29.3177 22.5484 25.9333 18.7665 24.0161 16.4963C22.5332 14.7387 22.1278 12.5025 21.0659 11.3046C21.0398 11.3203 21.0162 11.3386 20.9901 11.3543C20.059 12.0108 19.7817 13.3211 21.8793 16.1066C23.2001 17.8642 24.3012 19.4831 26.9402 22.3941Z",
    fill: "url(#paint7_linear_427_2284)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3675 22.5667C20.8514 23.0505 24.955 27.57 24.853 27.8107C26.1215 26.1028 21.2044 21.0837 18.8244 18.5467C16.7608 16.3472 16.4077 14.4222 14.3938 13.342C13.6458 14.247 14.2395 15.3559 14.5717 15.8398C14.9509 16.3916 19.8863 22.0854 20.3675 22.5667Z",
    fill: "url(#paint8_linear_427_2284)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7614 27.9129C24.6175 28.0018 24.322 28.0097 23.8643 27.7455C24.2043 28.0201 24.5181 28.1248 24.7614 27.9129Z",
    fill: "url(#paint9_linear_427_2284)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6371 16.5303C41.6912 16.342 41.8769 16.4623 41.6886 16.2687C41.1759 16.0778 40.6267 16.0124 40.3442 16.0124C39.2405 16.0124 36.4106 17.4274 36.4106 21.1518C36.4106 22.6007 35.9973 23.9111 34.5118 23.9111C33.9259 23.9111 33.3165 23.5946 32.728 23.1134C35.333 25.9982 37.3757 23.2808 37.6869 21.4186C37.9982 19.5564 37.5457 17.0848 40.6371 16.5303Z",
    fill: "url(#paint10_radial_427_2284)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6711 11.6368C20.0277 12.3665 20.0486 13.6742 21.8768 16.1066C23.2002 17.8642 24.2987 19.4805 26.9403 22.3941C27.4398 22.946 27.8897 23.6705 27.6988 23.8614C28.1408 20.8432 23.8436 17.8746 22.4469 15.5992C21.3406 13.7945 21.1209 12.73 20.6711 11.6368Z",
    fill: "url(#paint11_linear_427_2284)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3675 22.5667C20.8514 23.0506 24.955 27.5701 24.853 27.8107C25.7579 27.1647 25.1407 26.1577 23.7414 24.7585C20.8723 21.8893 16.8785 18.0341 15.2726 14.859C15.1209 14.5582 14.8385 14.3359 14.5063 14.2941C13.6406 14.1816 14.284 15.4187 14.5743 15.8398C14.9509 16.3916 19.8863 22.0855 20.3675 22.5667Z",
    fill: "url(#paint12_linear_427_2284)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6746 23.1552C15.202 24.8631 16.9596 26.605 18.6413 28.2789C19.9569 29.5866 22.9359 32.3511 22.609 32.6781C24.4555 31.1245 15.8794 25.5091 12.393 20.0664C12.1655 20.9269 12.7487 22.1169 13.6746 23.1552Z",
    fill: "url(#paint13_linear_427_2284)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2326 32.9867C22.4078 32.9187 22.4994 32.8376 22.5282 32.7487C22.2117 32.9919 21.7958 32.9056 20.972 32.1759C20.0749 31.3834 17.9537 29.1236 16.5728 28.0173C15.966 27.5335 15.3932 27.2641 14.8701 27.217C15.6181 27.6851 15.2703 27.8525 16.9337 29.1289C17.8282 29.8141 21.0923 33.4339 22.2326 32.9867Z",
    fill: "url(#paint14_linear_427_2284)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0591 24.7061C21.27 26.1813 23.6344 28.6162 24.6963 27.9441C24.4033 28.0435 23.7364 27.8813 22.6484 26.6965C21.5786 25.5326 18.7147 22.1875 17.0251 20.6705C15.6573 19.4412 14.5352 18.8005 13.5728 19.0228C16.3739 19.9434 18.9109 23.3121 20.0591 24.7061Z",
    fill: "url(#paint15_linear_427_2284)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3691 18.3585C23.3019 20.4613 26.1711 24.6329 27.6253 23.9032C27.3873 23.9765 26.8746 23.66 26.4745 23.2572C26.0272 22.81 22.0596 18.1074 21.1625 17.0978C19.996 15.7901 18.6177 13.4467 17.0327 12.73C18.6308 13.9907 19.8025 16.6558 21.3691 18.3585Z",
    fill: "url(#paint16_linear_427_2284)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7284 23.116C32.731 23.116 32.731 23.116 32.7284 23.116C31.8261 22.3784 30.9787 21.2511 30.3719 20.2913C29.3728 18.7037 25.2665 13.5983 24.2674 12.1494C23.9614 11.7074 23.6267 11.4014 23.2788 11.2078C23.7444 11.8774 24.0085 12.832 25.0625 14.0142C26.7521 15.9104 28.9622 19.3262 29.7207 20.5005C30.4765 21.6696 31.7006 24.1438 32.7284 23.116Z",
    fill: "url(#paint17_linear_427_2284)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2624 39.9542C37.6347 38.4268 36.7166 37.4957 35.3906 38.3692C31.7735 40.7519 27.6123 39.9464 22.3945 35.7302C17.7416 31.9666 15.3354 29.2779 13.0704 28.305C12.5264 29.5421 14.7652 31.5272 15.2935 32.0555C16.1383 32.9003 19.6064 36.1043 20.6761 36.8523C22.5043 38.1286 26.1607 43.2 30.9914 43.2C33.6932 43.1974 36.2929 41.8399 38.2624 39.9542Z",
    fill: "url(#paint18_linear_427_2284)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5849 23.6024C40.6529 20.5659 42.863 19.1169 42.863 17.6C42.863 17.1527 42.6302 16.8258 42.3006 16.5878C42.7034 17.77 41.7435 18.8188 40.3103 20.6025C38.7567 22.5353 38.4141 25.5352 39.4812 28.5378C40.5509 31.5403 39.204 35.6806 37.0305 36.9909C34.8571 38.3012 31.9696 44.0631 23.7022 37.5532C23.6996 37.5506 23.6996 37.5506 23.697 37.548C23.1922 37.0798 22.6926 36.664 22.1878 36.3501C18.6962 34.1871 16.7059 32.2413 15.202 30.6066C14.9064 30.2849 14.1113 29.053 13.1646 29.4584C13.6379 30.5308 14.9117 31.6737 15.2935 32.0556C16.1383 32.9003 19.6064 36.1043 20.6761 36.8523C20.8147 36.9491 20.9664 37.0694 21.126 37.208C21.1678 37.2446 21.2097 37.2812 21.2515 37.3178C21.262 37.3283 21.2751 37.3388 21.2855 37.3466C21.3117 37.3701 21.3404 37.3963 21.3666 37.4198C21.3718 37.4251 21.3797 37.4303 21.3849 37.4381C22.4703 38.4242 23.9637 40.0562 25.7945 41.3299C25.7945 41.3299 25.7972 41.3299 25.7972 41.3326C25.9567 41.445 26.1215 41.5549 26.2863 41.6595C26.2889 41.6621 26.2915 41.6621 26.2941 41.6647C26.4589 41.7693 26.6263 41.8713 26.7937 41.9681C26.7963 41.9681 26.7963 41.9707 26.7989 41.9707C28.0648 42.6978 29.4693 43.2 30.9862 43.2C36.5754 43.2 41.7514 37.3701 41.7514 33.0913C41.7514 28.8124 40.5038 27.1908 40.5849 23.6024Z",
    fill: "url(#paint19_radial_427_2284)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_427_2284",
    x1: 39.042,
    y1: 44.3042,
    x2: 34.4363,
    y2: 33.5138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_427_2284",
    x1: 39.9589,
    y1: 36.7994,
    x2: 30.2988,
    y2: 25.2764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_427_2284",
    x1: 14.1385,
    y1: 29.1278,
    x2: 19.831,
    y2: 33.3195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_427_2284",
    x1: 12.0656,
    y1: 18.0331,
    x2: 22.0534,
    y2: 28.4866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_427_2284",
    x1: 19.7328,
    y1: 24.2407,
    x2: 16.4312,
    y2: 27.3509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_427_2284",
    x1: 22.8536,
    y1: 13.1011,
    x2: 28.6496,
    y2: 22.2091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_427_2284",
    x1: 16.8708,
    y1: 14.6142,
    x2: 24.7368,
    y2: 25.2402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_427_2284",
    x1: 26.2257,
    y1: 15.8964,
    x2: 21.2577,
    y2: 20.3814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_427_2284",
    x1: 21.6558,
    y1: 19.0917,
    x2: 14.8248,
    y2: 24.0856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_427_2284",
    x1: 26.7444,
    y1: 26.0526,
    x2: 19.9133,
    y2: 31.0464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_427_2284",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.7078 17.9449) scale(8.20085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_427_2284",
    x1: 27.1349,
    y1: 15.0156,
    x2: 22.8914,
    y2: 18.9486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_427_2284",
    x1: 23.8853,
    y1: 17.1473,
    x2: 18.2962,
    y2: 22.1843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_427_2284",
    x1: 21.9964,
    y1: 22.5954,
    x2: 15.0964,
    y2: 28.3914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_427_2284",
    x1: 14.4677,
    y1: 26.8058,
    x2: 22.489,
    y2: 33.3264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_427_2284",
    x1: 16.0029,
    y1: 18.7235,
    x2: 22.2647,
    y2: 28.2456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_427_2284",
    x1: 20.9075,
    y1: 19.4038,
    x2: 22.667,
    y2: 18.0583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_427_2284",
    x1: 29.5905,
    y1: 24.7196,
    x2: 27.2445,
    y2: 13.5415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_427_2284",
    x1: 24.2347,
    y1: 35.4476,
    x2: 20.7157,
    y2: 38.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_427_2284",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5655 24.7583) rotate(48.14) scale(23.7707 21.5763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavingHand);
export default __webpack_public_path__ + "static/media/waving-hand.75fdc7a17b3d03805546f2c7df6efe8f.svg";
export { ForwardRef as ReactComponent };